<template>
  <div class="navbar-button mr-3" @click="$emit('click')">
    <font-awesome-icon :icon="icon" class="navbar-button-icon" />
  </div>
</template>

<script>
export default {
  name: 'navbar-button',
  components: {},
  props: {
    icon: Array,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.navbar-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  // border: 1px solid white;
  background-color: #ffffff1a;
  border-radius: 40px;
  cursor: pointer;
  &:hover {
    .navbar-button-icon {
      color: $blue-mayday;
    }
  }
  &:active {
    box-shadow: 0px 15px 30px $shadow-4-mayday;
  }
  &:hover {
    background-color: #ffffff;
  }
}
.navbar-button-icon {
  margin: 8px;
  color: white;
  &:active {
    color: $blue-mayday;
  }
}
</style>
